import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { productPath } from '../utils/productUrl';
import './ProductCard.css';

const { FiHeart, FiShoppingBag } = FiIcons;
const WISHLIST_KEY = 'darshana-wishlist';

function getWishlist() {
  try {
    return JSON.parse(window.localStorage.getItem(WISHLIST_KEY) || '[]');
  } catch {
    return [];
  }
}

function ProductCard({ product, onAdd }) {
  const [favorite, setFavorite] = useState(() => getWishlist().includes(product.id));
  const path = productPath(product);

  const toggleWishlist = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const wishlist = getWishlist();
    const updatedWishlist = favorite
      ? wishlist.filter((id) => id !== product.id)
      : [...new Set([...wishlist, product.id])];

    window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(updatedWishlist));
    window.dispatchEvent(new Event('darshana-wishlist-updated'));
    setFavorite(!favorite);
  };

  return (
    <article className="product-card">
      <Link to={path} className="product-image-link">
        <div className="product-image">
          {!product.available && <span className="stock-label">Sold out</span>}
          <img src={product.image} alt={product.name} loading="lazy" />
        </div>
      </Link>
      <div className="product-copy">
        <Link to={path} className="product-title-link">
          <p className="product-category">{product.category}</p>
          <h3 title={product.name}>{product.name}</h3>
        </Link>
        <div className="product-meta">
          <div className="product-stock-info">
            <span>{product.weight}</span>
            {product.stock_quantity != null && (
              <span className="product-stock-count">{Math.max(0, Number(product.stock_quantity))} left in stock</span>
            )}
          </div>
          <strong>Rs. {product.price.toLocaleString()}</strong>
        </div>
        <button
          className="add-button"
          disabled={!product.available}
          onClick={() => onAdd(product)}
        >
          <SafeIcon icon={FiShoppingBag} />
          {product.available ? 'Add to Cart' : 'Out of Stock'}
        </button>
      </div>
    </article>
  );
}

export default ProductCard;